import React from 'react';
import { getPlanDetails } from '../../utils/plans';

interface ProUpsellProps {
  feature: string;
  onClose?: () => void;
}

const ProUpsell: React.FC<ProUpsellProps> = ({ feature, onClose }) => {
  const pro = getPlanDetails('pro');
  return (
    <div
      role="status"
      className="relative mt-3 rounded-xl border border-indigo-200 bg-gradient-to-r from-indigo-50 to-purple-50 p-4"
    >
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss"
          className="absolute right-2 top-2 rounded px-2 text-slate-400 hover:text-slate-600"
        >
          ×
        </button>
      )}
      <p className="m-0 pr-6 text-sm font-semibold text-slate-800">
        🔒 {feature} is part of Pro
      </p>
      <p className="m-0 mt-1 text-xs text-slate-600">
        Upgrade for £{pro.monthlyPrice}/month. You only pay the difference for
        the rest of this billing month.
      </p>
      <a
        href="/account"
        className="mt-3 inline-block rounded-lg bg-gradient-to-r from-indigo-500 to-purple-600 px-4 py-2 text-xs font-semibold text-white no-underline hover:from-indigo-600 hover:to-purple-700"
      >
        Upgrade to Pro
      </a>
    </div>
  );
};

export default ProUpsell;
